module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "lista-de-solicitacoes"
    }
  }, [_c('div', {
    staticClass: "container_pequeno container_com-fundo container_com-margem u-padding-media"
  }, [_c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel,
      "mensagem": _vm.loading.mensagem
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grade__linha u-margem-inferior-media"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_6"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nome),
      expression: "nome"
    }],
    staticClass: "formulario__input",
    attrs: {
      "name": "nome",
      "type": "text",
      "id": "nome",
      "placeholder": "Nome"
    },
    domProps: {
      "value": (_vm.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nome = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_3"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "cpf"
    }
  }, [_vm._v("CPF")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('999.999.999-99'),
      expression: "'999.999.999-99'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.cpf),
      expression: "cpf"
    }],
    staticClass: "formulario__input",
    attrs: {
      "name": "cpf",
      "type": "text",
      "id": "cpf",
      "placeholder": "CPF"
    },
    domProps: {
      "value": (_vm.cpf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cpf = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_3"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataDeAprovacao),
      expression: "dataDeAprovacao"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "data-de-avaliacao",
      "type": "date"
    },
    domProps: {
      "value": (_vm.dataDeAprovacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataDeAprovacao = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha_alinhar-horizontal-direita formulario-button"
  }, [_c('button', {
    staticClass: "botao botao_cor-terciaria botao_contorno botao_medio u-margem-direita-media",
    attrs: {
      "type": "button",
      "disabled": _vm.deveDesabilitarBotaoDeLimpar
    },
    on: {
      "click": function($event) {
        return _vm.limparFormulario()
      }
    }
  }, [_vm._v("\n        Limpar\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_cor-terciaria botao_medio u-margem-direita-pequena",
    attrs: {
      "type": "button",
      "disabled": _vm.deveDesabilitarBotaoDePesquisa
    },
    on: {
      "click": function($event) {
        return _vm.obterSolicitacoes(this.paginaAtual)
      }
    }
  }, [_vm._v("\n        Pesquisar\n      ")])]), _vm._v(" "), (_vm.existemSolicitacoesParaValidacaoDaMinuta) ? _c('hr', {
    staticClass: "u-margem-superior-grande u-margem-inferior-grande"
  }) : _vm._e(), _vm._v(" "), (_vm.existemSolicitacoesParaValidacaoDaMinuta) ? _c('div', {
    staticClass: "grade__linha u-margem-inferior-media"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), (
    _vm.foiRealizadaAlgumaPesquisa &&
    !_vm.existemSolicitacoesParaValidacaoDaMinuta
  ) ? _c('div', {
    staticClass: "grade__linha u-margem-superior-pequena"
  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.existemSolicitacoesParaValidacaoDaMinuta) ? _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_12"
  }, [_c('table', {
    staticClass: "tabela tabela_listrada tabela_com-largura-total"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.solicitacoes), function(solicitacao) {
    return _c('tr', {
      attrs: {
        "id": solicitacao.Id
      }
    }, [_c('td', [_vm._v(_vm._s(solicitacao.Nome))]), _vm._v(" "), _c('td', {
      staticClass: "u-texto-alinhado-ao-centro"
    }, [_vm._v("\n                " + _vm._s(solicitacao.Cpf) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "u-texto-alinhado-ao-centro"
    }, [_vm._v("\n                " + _vm._s(solicitacao.DataDeAprovacao) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "u-texto-alinhado-ao-centro no-print"
    }, [_c('div', {
      staticClass: "dropdown dropdown_direita"
    }, [_c('button', {
      staticClass: "botao botao_cor-terciaria botao_contorno botao_pequeno",
      attrs: {
        "aria-haspopup": "true"
      },
      on: {
        "click": function($event) {
          return _vm.visualizarCertificado(solicitacao.Id)
        }
      }
    }, [_vm._v("\n                    Visualizar\n                  ")])])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.existemSolicitacoesParaValidacaoDaMinuta) ? _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_12"
  }, [_c('paginacao', {
    attrs: {
      "paginaAtual": _vm.paginaAtual,
      "totalDePaginas": _vm.totalDePaginas,
      "totalDeRegistros": _vm.totalDeRegistros
    },
    on: {
      "paginar": _vm.obterSolicitacoes
    }
  })], 1)]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grade__linha grade__linha_alinhar-vertical-ao-topo"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_3"
  }, [_c('div', {
    staticClass: "titulo titulo_grande u-margem-inferior-pequena"
  }, [_vm._v("\n          Filtros\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "dataDeAssinatura"
    }
  }, [_vm._v("Data de aprovação\n          "), _c('span', {
    staticClass: "tooltips"
  }, [_c('i', {
    staticClass: "far fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "conteudo tooltip-top"
  }, [_vm._v("Data em que a solicitação foi aprovada pela AGEHAB\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grade__coluna grade__coluna_6"
  }, [_c('div', {
    staticClass: "titulo titulo_grande u-margem-inferior-pequena"
  }, [_vm._v("\n          Lista de minutas a validar\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grade__coluna grade__coluna_12"
  }, [_c('div', {
    staticClass: "estado-vazio"
  }, [_c('i', {
    staticClass: "far fa-align-slash estado-vazio__icone"
  }), _vm._v(" "), _c('h2', {
    staticClass: "estado-vazio__titulo"
  }, [_vm._v("Nenhum resultado encontrado")]), _vm._v(" "), _c('p', {
    staticClass: "estado-vazio__texto"
  }, [_vm._v("\n            Você pode buscar solicitações pelo "), _c('strong', [_vm._v("nome")]), _vm._v(",\n            "), _c('strong', [_vm._v("CPF")]), _vm._v(" ou pela "), _c('strong', [_vm._v("data de aprovação")]), _vm._v(".\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticClass: "u-texto-alinhado-ao-centro"
  }, [_vm._v("CPF")]), _vm._v(" "), _c('th', {
    staticClass: "u-texto-alinhado-ao-centro"
  }, [_vm._v("\n                Data de aprovação\n                "), _c('span', {
    staticClass: "tooltips"
  }, [_c('i', {
    staticClass: "far fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "conteudo tooltip-top"
  }, [_vm._v("Data em que a solicitação foi aprovada pela AGEHAB\n                  ")])])]), _vm._v(" "), _c('th', {
    staticClass: "u-texto-alinhado-ao-centro no-print"
  }, [_vm._v("Visualizar")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65891a7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controle-de-solicitacoes/mcmv-cidades/ListaDeValidacaoDeMinutas.vue
// module id = 1121
// module chunks = 1